import { defineComponent as v, mergeModels as T, useModel as y, computed as d, openBlock as r, createElementBlock as n, normalizeClass as o, createElementVNode as t, withModifiers as f, renderSlot as m, createCommentVNode as k } from "vue";
import { _ as C } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './assets/BaseComplexToggle.css';const $ = ["id", "data-cy"], B = ["data-btn-bg-color", "data-cy"], L = ["src", "alt"], M = ["innerHTML"], z = ["data-btn-bg-color", "data-cy"], V = ["src", "alt"], w = ["innerHTML"], H = /* @__PURE__ */ v({
  __name: "BaseComplexToggle",
  props: /* @__PURE__ */ T({
    labels: {},
    type: { default: "full" },
    mode: { default: "" },
    btnBgColor: { default: "uikit-bg-w-lavender" },
    borderContainerColor: { default: "uikit-border-w-secondary" },
    size: { default: "" }
  }, {
    modelValue: {
      default: null
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(g) {
    const l = g, a = y(g, "modelValue"), s = () => {
      a.value = l.labels.leftToggle;
    }, u = () => {
      a.value = l.labels.rightToggle;
    };
    (() => {
      if (l.labels.leftToggle.checked) {
        s();
        return;
      }
      if (l.labels.rightToggle.checked) {
        u();
        return;
      }
      s();
    })();
    const b = (e) => a.value?.label === e.label, c = d(() => b(l.labels.leftToggle)), p = d(() => b(l.labels.rightToggle));
    return (e, i) => (r(), n("div", {
      id: e.$attrs.id || "",
      "data-cy": e.$attrs["data-cy"] || "",
      class: o(["base-complex-toggle uikit-relative uikit-flex uikit-justify-center uikit-p-0", [e.mode, e.borderContainerColor, e.size]])
    }, [
      t("div", {
        "data-btn-bg-color": e.btnBgColor,
        "data-cy": `bct-left-btn${e.labels.leftToggle.label ? `-${e.labels.leftToggle.label}` : ""}`,
        class: o(["left-button uikit-flex uikit-flex-1 uikit-items-center uikit-justify-center hover:uikit-cursor-pointer", [
          {
            "base-complex-toggle-active": c.value
          }
        ]]),
        onClick: i[0] || (i[0] = f((h) => s(), ["stop"]))
      }, [
        m(e.$slots, "left_icon", {}, () => [
          e.labels.leftToggle.icon ? (r(), n("img", {
            key: 0,
            class: "base-complex-toggle-icon uikit-relative uikit-z-10 uikit-mr-10px",
            src: e.labels.leftToggle.icon.src,
            alt: e.labels.leftToggle.icon.alt,
            width: "15",
            height: "15"
          }, null, 8, L)) : k("", !0)
        ], !0),
        t("span", {
          class: "base-complex-toggle-label uikit-relative uikit-z-10",
          innerHTML: e.labels.leftToggle.label
        }, null, 8, M)
      ], 10, B),
      t("div", {
        "data-btn-bg-color": e.btnBgColor,
        "data-cy": `bct-right-btn${e.labels.rightToggle.label ? `-${e.labels.rightToggle.label}` : ""}`,
        class: o(["right-button uikit-flex uikit-flex-1 uikit-items-center uikit-justify-center hover:uikit-cursor-pointer", [
          {
            "base-complex-toggle-active": p.value
          }
        ]]),
        onClick: i[1] || (i[1] = f((h) => u(), ["stop"]))
      }, [
        m(e.$slots, "right_icon", {}, () => [
          e.labels.rightToggle.icon ? (r(), n("img", {
            key: 0,
            class: "base-complex-toggle-icon uikit-relative uikit-z-10 uikit-mr-10px",
            src: e.labels.rightToggle.icon.src,
            alt: e.labels.rightToggle.icon.alt,
            width: "15",
            height: "15"
          }, null, 8, V)) : k("", !0)
        ], !0),
        t("span", {
          class: "base-complex-toggle-label uikit-relative uikit-z-10",
          innerHTML: e.labels.rightToggle.label
        }, null, 8, w)
      ], 10, z),
      t("div", {
        class: o(["uikit-absolute uikit-transition-all uikit-duration-200 uikit-ease-out", [
          e.type === "full" ? "base-complex-toggle-active-bg" : "base-complex-toggle-active-padded-bg",
          e.btnBgColor,
          e.mode,
          c.value ? "translateX-left" : "translateX-right"
        ]])
      }, null, 2)
    ], 10, $));
  }
}), N = /* @__PURE__ */ C(H, [["__scopeId", "data-v-694c2fae"]]);
export {
  N as default
};
